import { PatientMonitoringType } from "../../api";

/**
 * Where opening a patient lands. A screening patient only bundles a screening
 * user's PPGs, so its Trends page has nothing to show.
 */
export function patientPath(patient: {
  patient_id: number;
  monitoring_type?: PatientMonitoringType | null;
}) {
  return patient.monitoring_type === PatientMonitoringType.screening
    ? `/patient/${patient.patient_id}/raw/ppg`
    : `/patient/${patient.patient_id}`;
}
